import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { isAdmin } from '../utils/role';

export default function Teams() {
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [members, setMembers] = useState([]);
  const [teamModal, setTeamModal] = useState(null); // { item }
  const [form, setForm] = useState({});
  const [memberForm, setMemberForm] = useState(null); // add-member form
  const [err, setErr] = useState('');
  const admin = isAdmin();

  const loadTeams = async () => {
    const r = await api.get('/teams').catch(() => ({ data: [] }));
    setTeams(r.data);
    return r.data;
  };
  const loadUsers = async () => {
    const r = await api.get('/users/lookup').catch(() => ({ data: [] }));
    setUsers(r.data);
  };
  useEffect(() => { loadTeams(); loadUsers(); }, []);

  const selectTeam = async (t) => {
    setSelected(t); setMemberForm(null);
    const r = await api.get(`/teams/${t.id}/members`).catch(() => ({ data: [] }));
    setMembers(r.data);
  };

  const mains = teams.filter(t => !t.parentId);
  const subsOf = (id) => teams.filter(t => t.parentId === id);

  const openTeam = (item, parentId = null) => {
    setTeamModal({ item }); setErr('');
    setForm(item ? { ...item } : { name: '', parentId, leadUsername: '', active: true });
  };

  const saveTeam = async () => {
    setErr('');
    if (!form.name) { setErr('Name is required'); return; }
    const b = { name: form.name, parentId: form.parentId || null, leadUsername: form.leadUsername || null, active: form.active !== false };
    try {
      teamModal.item ? await api.put(`/teams/${teamModal.item.id}`, b) : await api.post('/teams', b);
      setTeamModal(null); const list = await loadTeams();
      if (selected) setSelected(list.find(x => x.id === selected.id) || null);
    } catch (e) { setErr(e.response?.data?.error || 'Save failed'); }
  };

  const addMember = async () => {
    setErr('');
    if (!memberForm.username) { setErr('Select a user'); return; }
    const u = users.find(x => x.username === memberForm.username);
    const b = { username: memberForm.username, fullName: u?.fullName || memberForm.username, roleInTeam: memberForm.roleInTeam || 'ENGINEER' };
    try {
      await api.post(`/teams/${selected.id}/members`, b);
      setMemberForm(null); selectTeam(selected);
    } catch (e) { setErr(e.response?.data?.error || 'Add failed'); }
  };

  const removeMember = async (m) => {
    if (!window.confirm(`Remove ${m.fullName} from ${selected.name}?`)) return;
    await api.delete(`/teams/${selected.id}/members/${m.id}`);
    selectTeam(selected);
  };

  const TeamRow = ({ t, sub }) => (
    <div onClick={() => selectTeam(t)} style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '9px 12px', paddingLeft: sub ? 30 : 12, cursor: 'pointer', borderRadius: 8,
      background: selected?.id === t.id ? 'rgba(124,58,237,0.12)' : 'transparent',
      color: t.active ? '#0f172a' : '#94a3b8',
    }}>
      <span style={{ fontWeight: sub ? 400 : 600, fontSize: 14 }}>{sub ? '↳ ' : ''}{t.name}{!t.active && ' (inactive)'}</span>
      {admin && <span style={{ display: 'flex', gap: 6 }}>
        {!sub && <button className="btn-ghost" style={{ padding: '2px 8px', fontSize: 11 }} onClick={e => { e.stopPropagation(); openTeam(null, t.id); }}>+ Sub</button>}
        <button className="btn-ghost" style={{ padding: '2px 8px', fontSize: 11 }} onClick={e => { e.stopPropagation(); openTeam(t); }}>Edit</button>
      </span>}
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a' }}>Support Teams</h1>
        {admin && <button className="btn-primary" onClick={() => openTeam(null, null)}>+ New Team</button>}
      </div>
      <p style={{ color: '#64748b', marginBottom: 16 }}>Main teams and sub-teams with their members</p>

      <div style={{ display: 'grid', gridTemplateColumns: '340px 1fr', gap: 16 }}>
        <div className="card" style={{ padding: 10 }}>
          {mains.length === 0 && <div style={{ color: '#94a3b8', fontSize: 13, padding: 8 }}>No teams yet.</div>}
          {mains.map(t => (
            <div key={t.id}>
              <TeamRow t={t} />
              {subsOf(t.id).map(s => <TeamRow key={s.id} t={s} sub />)}
            </div>
          ))}
        </div>

        <div className="card">
          {!selected ? (
            <div style={{ color: '#94a3b8', fontSize: 14, textAlign: 'center', padding: 40 }}>Select a team to view its members</div>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>{selected.name}</div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{selected.parentId ? 'Sub-team' : 'Main team'}{selected.leadUsername ? ` · Lead: ${selected.leadUsername}` : ''}</div>
                </div>
                {admin && <button className="btn-primary" style={{ fontSize: 13, padding: '6px 14px' }} onClick={() => { setMemberForm({ username: '', roleInTeam: 'ENGINEER' }); setErr(''); }}>+ Member</button>}
              </div>

              {memberForm && (
                <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', margin: '14px 0', padding: 12, background: 'var(--gray-50)', borderRadius: 10 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: 12, fontWeight: 500 }}>User</label>
                    <select value={memberForm.username} onChange={e => setMemberForm({ ...memberForm, username: e.target.value })}>
                      <option value="">— Select —</option>
                      {users.map(u => <option key={u.username} value={u.username}>{u.fullName} ({u.username})</option>)}
                    </select>
                  </div>
                  <div style={{ width: 150 }}>
                    <label style={{ fontSize: 12, fontWeight: 500 }}>Role</label>
                    <select value={memberForm.roleInTeam} onChange={e => setMemberForm({ ...memberForm, roleInTeam: e.target.value })}>
                      <option value="ENGINEER">Engineer</option>
                      <option value="TEAM_LEAD">Team Lead</option>
                    </select>
                  </div>
                  <button className="btn-primary" onClick={addMember}>Add</button>
                  <button className="btn-ghost" onClick={() => setMemberForm(null)}>Cancel</button>
                </div>
              )}
              {err && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '8px 12px', margin: '10px 0', fontSize: 13 }}>{err}</div>}

              <table style={{ marginTop: 12 }}>
                <thead><tr><th>Name</th><th>Username</th><th>Role in team</th>{admin && <th></th>}</tr></thead>
                <tbody>
                  {members.length === 0 && <tr><td colSpan={admin ? 4 : 3} style={{ color: '#94a3b8', fontSize: 13 }}>No members yet.</td></tr>}
                  {members.map(m => (
                    <tr key={m.id}>
                      <td style={{ fontWeight: 600 }}>{m.fullName}</td>
                      <td>{m.username}</td>
                      <td><span className="badge badge-info">{m.roleInTeam}</span></td>
                      {admin && <td><button className="btn-ghost" style={{ padding: '4px 10px', fontSize: 12, color: '#dc2626' }} onClick={() => removeMember(m)}>Remove</button></td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>

      {teamModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }} onClick={() => setTeamModal(null)}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 400 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontWeight: 700, marginBottom: 18, color: '#0f172a' }}>{teamModal.item ? 'Edit Team' : (form.parentId ? 'New Sub-team' : 'New Team')}</h3>
            {err && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{err}</div>}
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Name *</label>
              <input value={form.name || ''} onChange={e => setForm({ ...form, name: e.target.value })} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Parent team</label>
              <select value={form.parentId || ''} onChange={e => setForm({ ...form, parentId: e.target.value ? Number(e.target.value) : null })}>
                <option value="">— None (main team) —</option>
                {mains.filter(m => m.id !== teamModal.item?.id).map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Team lead</label>
              <select value={form.leadUsername || ''} onChange={e => setForm({ ...form, leadUsername: e.target.value })}>
                <option value="">— None —</option>
                {users.map(u => <option key={u.username} value={u.username}>{u.fullName} ({u.username})</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" checked={form.active !== false} onChange={e => setForm({ ...form, active: e.target.checked })} style={{ width: 'auto' }} /> Active</label>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn-primary" onClick={saveTeam} style={{ flex: 1 }}>{teamModal.item ? 'Update' : 'Create'}</button>
              <button className="btn-ghost" onClick={() => setTeamModal(null)} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
